









































































































































import { cloneDeep } from 'lodash'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import { SelectOption } from '../../../logic/types'
import { UseFields } from '../../Pi'
import CurrenciesHelperMixin from "../../Shop/CurrenciesHelperMixin";
import ProductsEditor from './ProductEditor.vue'
import ProductsCore from './index'

@Component({
  components: {
    ProductsEditor,
  },
  data() {
    return {
      cloneDeep,
    }
  }
})
export default class ShopProducts extends Mixins(UseFields, CurrenciesHelperMixin) {
  @Prop() core!: ProductsCore

  @Prop() currencyList!: Array<SelectOption>

  editableProducts: number | null = null

  archiveIsOpen = false

  isLoading = false

  removeProduct(id: number): void {
    this.$confirm({
      title: this.$t('delete').toString(),
      content: this.$t('shop_remove_product_alert_text').toString(),
      okText: this.$t('accept').toString(),
      okType: 'danger',
      cancelText: this.$t('reject').toString(),
      centered: true,
      onOk: () => {
        this.isLoading = true
        this.core.removeProductHandler(id).finally(() => this.isLoading = false)
      }
    })
  }

  restoreProduct(id: number): void {
    this.core.restoreProductHandler(id)
  }

}
